import apiClient from "./apiClient";

/* Subscription plans for current user type */
export const getSubscriptionPlans = async () => {
    const userTypeId = localStorage.getItem('user_type_id');

    try {
        const response = await apiClient.get(`/api/subscription/${userTypeId}`);

        if (response.status === 200) {
            return { status: true, body: response.data };
        } else {
            return { status: false, error: "failed" };
        }
    } catch (error: any) {
        return {
            status: false,
            error: "An error occurred. Please try again later.",
        };
    }
};

/* Payment types */
export const getPaymentTypes = async () => {
    try {
        const response = await apiClient.get(`/api/payment-type`);

        if (response.status === 200) {
            return { status: true, body: response.data };
        } else {
            return { status: false, error: "failed" };
        }
    } catch (error: any) {
        return {
            status: false,
            error: "An error occurred. Please try again later.",
        };
    }
};